module.exports = __webpack_public_path__ + "img/地热国入口.99ab7faa.jpg";